import { render, staticRenderFns } from "./Forfeiture.vue?vue&type=template&id=095f57d2&"
import script from "./Forfeiture.vue?vue&type=script&lang=js&"
export * from "./Forfeiture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports